var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeparture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow_circle_right_FILL0_wght600_GRAD200_opsz20",
    d: "M65.979-889.6l4.315-4.315-4.315-4.315-1.908,1.921,1.038,1.038H62.076v2.712H65.11l-1.038,1.038Zm.107,5.685a9.865,9.865,0,0,1-3.889-.775A9.97,9.97,0,0,1,59-886.829a9.97,9.97,0,0,1-2.141-3.195,9.865,9.865,0,0,1-.775-3.889,9.829,9.829,0,0,1,.776-3.906A10.034,10.034,0,0,1,59.009-901a9.938,9.938,0,0,1,3.195-2.139,9.883,9.883,0,0,1,3.882-.77,9.908,9.908,0,0,1,3.906.769A9.947,9.947,0,0,1,73.178-901a9.944,9.944,0,0,1,2.139,3.186,9.914,9.914,0,0,1,.769,3.907,9.866,9.866,0,0,1-.77,3.885,9.953,9.953,0,0,1-2.139,3.189,10.034,10.034,0,0,1-3.185,2.147A9.83,9.83,0,0,1,66.086-883.913Zm0-2.712a7.041,7.041,0,0,0,5.17-2.118,7.025,7.025,0,0,0,2.121-5.167,7.041,7.041,0,0,0-2.118-5.17,7.025,7.025,0,0,0-5.167-2.121,7.041,7.041,0,0,0-5.17,2.118,7.025,7.025,0,0,0-2.121,5.167,7.04,7.04,0,0,0,2.118,5.17A7.025,7.025,0,0,0,66.083-886.625ZM66.086-893.913Z",
    transform: "translate(-56.086 903.913)",
    fill: "var(--primary-color)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeparture);
export default __webpack_public_path__ + "static/media/departure.7d7287ea1da812085b6abc9a457a53cf.svg";
export { ForwardRef as ReactComponent };